import { render, staticRenderFns } from "./progressBar.vue?vue&type=template&id=2d661020&scoped=true"
import script from "./progressBar.vue?vue&type=script&lang=js"
export * from "./progressBar.vue?vue&type=script&lang=js"
import style0 from "./progressBar.vue?vue&type=style&index=0&id=2d661020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d661020",
  null
  
)

export default component.exports